export enum AutomationTagIds {
  'heading.password' = 'test-heading-password',
  'button.next' = 'test-button-next',
  'button.backarrow' = 'test-button-backarrow',
  'text.userid' = 'test-text-userid',
  'input.password' = 'test-input-password',
  'link.forgotpassword' = 'test-link-forgotpassword',
  'title.devices' = 'test-title-devices',
  'subtitle.devices' = 'test-subtitle-devices',
  'link.findId' = 'test-link-findId',
  'section.findyourdevice' = 'test-section-findyourdevice',
  'section.recentsignin' = 'test-section-recentsignin',
  'title.norecentsignin' = 'test-title-norecentsignin',
  'section.inactive' = 'test-section-inactive',
  'title.noactivedevice' = 'test-title-noactivedevice',
  'section.registerdevice' = 'test-section-registerdevice',
  'title.nodeviceregister' = 'test-title-nodeviceregister',
  'button.myaccount' = 'test-button-myaccount',
  'parent-box.alltab' = 'test-parent-box-alltab',
  'title.popup' = 'test-title-popup',
  'subheading.security.popup' = 'test-subheading-security-popup',
  'user.email' = 'test-user-email',
  'link.onetimeemail' = 'test-onetimeemail',
  'button.cancel' = 'test-button-cancel',
  'button.ok' = 'test-button-ok',
  'list.recentsignindevice' = 'test-list-recentsignindevice',
  'button.recentsignin.signout' = 'test-button-recentsignin-signout',
  'list.registerdevice' = 'test-list-registerdevice',
  'list.registerdevice.serialno' = 'test-list-registerdevice-serialno',
  'list.inactivedevice' = 'test-list-inactivedevice',
  'button.inactivedevice.remove' = 'test-button-inactivedevice.remove',
  'button.menu-tab' = 'test-button.menu-tab',
  'cards.dashboard-title' = 'test-cards.dashboard-title-',
  'cards.dashboard-services-list' = 'test-cards-dashboard-services-list',
  'cards.dashboard-connected-services-list' = 'test-cards-dashboard-connected-services-list',
  'cards.dashboard-recent-signins' = 'test-cards-dashboard-recent-signins',
  'cards.dashboard-registered-devices' = 'test-cards-dashboard-registered-devices',
  'cards.dashboard-recent-activity-devices' = 'test-cards-dashboard-recent-activity-devices',
  'cards.dashboard-privacy-notice' = 'test-cards-dashboard-privacy-notice',
  'cards.dashboard-scloud-data' = 'test-cards-dashboard-scloud-data',
  'cards.dashboard-places-data' = 'test-cards-dashboard-places-data',
  'cards.dashboard-profile-icon' = 'test-cards-dashboard-profile-icon',
  'cards.dashboard-profile-data' = 'test-cards-dashboard-profile-data',
  'tab.heading' = 'test-tab-heading',
  'tab.subheading' = 'test-tab-subheading',
  'section.heading' = 'test-section-heading',
  'list.heading' = 'test-list-heading',
  'list.places.delete' = 'test-list-places-delete',
  'tab.heading.services' = 'test-tab-heading-services',
  'tab.heading.connected.services' = 'test-tab-heading-connected-services',
  'section.notconnected.services' = 'test-section-notconnected-services',
  'dialog.text.verify' = 'test-dialog-text-verify',
  'about.section.privacy' = 'test-about-section-privacy',
  'button.samsung.privacy' = 'test-button-samsung-privacy',
  'section.headline' = 'test-section-headline',
  'heading.customization.service' = 'test-heading-customization-service',
  'heading.personalized.advertising' = 'test-heading-personalized-advertising',
  'section.description' = 'test-section-description',
  'section.content' = 'test-section-content',
  'button.forwardarrow' = 'test-button-forwardarrow',
  'list.account.recovery' = 'test-list-account-recovery',
  'text.not.registered' = 'test-text-not-registered',
  'button.edit.personal.information' = 'test-button-edit-personal-information',
  'description.recovery.number' = 'test-description-recovery-number',
  'button.add' = 'test-button-add',
  'subheading.customization.service' = 'test-subheading-customization-service',
  'button.checkbox' = 'test-button-checkbox',
  'heading.data.management' = 'test-heading-data-management',
  'description.data.management' = 'test-description-data-management',
  'heading.mobile.devices' = 'test-heading-mobile-devices',
  'heading.call.message.history' = 'test-heading-call-message-history',
  'heading.browsing.history' = 'test-heading-browsing-history',
  'heading.listening.information' = 'test-heading-listening-information',
  'heading.location' = 'test-heading-location',
  'heading.search.data' = 'test-heading-search-data',
  'heading.viewing.information' = 'test-heading-viewing-information',
  'heading.tv' = 'test-heading-tv',
  'button.send.code' = 'test-button-send-code',
  'title.profile.username' = 'test-title-profileusername',
  'subtitle.profile.userID' = 'test-subtitle-profileuserID',
  'button.profile.userphoto' = 'test-button-profile-userphoto',
  'label.profile' = 'test-label',
  'label.inputvalue' = 'test-input',
  'button.change.password.description' = 'test-button-change-password-description',
  'button.tsv.state' = 'test-button-tsv-state',
  'recent.activity.description' = 'test-recent-activity-description',
  'listitem.description' = 'test-item-description',
  'button.save' = 'test-button-save',
  'list.personalinfo' = 'test-user-personalinfo',
  'text-userinfo' = 'test-user',
  'button.managesamsungaccount' = 'test-button-managesamsungaccount',
  'button.change' = 'test-button-change',
  'button.verify' = 'test-button-verify',
  'user.old.email' = 'test-user-old-email',
  'button.sendcode' = 'test-button-sendcode',
  'select.country' = 'test-select-countrycode',
  'input.phonenumber' = 'test-input-phonenumber',
  'button.setup' = 'test-button-setup',
  'dashboard.intro.signintext' = 'test-dashboard-intro-signintext',
  'button.dashboard.intro.signin' = 'test-button-dashboard-intro-signin',
  'dashboard.benefits.textcontent' = 'test-dashboard-benefits-textcontent',
  'dashboard.benefits.notecontent' = 'test-dashboard-benefits-notecontent',
  'dashboard.languagelocation.select' = 'test-dashboard-languagelocation-select',
  'dashboard.footer.select' = 'test-dashboard-footer-select',
  'dashboard.copyright.select' = 'test-dashboard-copyright-select',
  'dashboard.header.signup' = 'test-dashboard-header-ignup',
  'policies.tnc.page' = 'test-policies-tnc-page',
  'button.policies.download' = 'test-button-policies-download',
  'button.person.icon' = 'test-button.person.icon',
  'button.signout' = 'test-button.signout',
  'text.user.detail' = 'test-text.user.detail',

  // Sign-In Flow
  'input.signin.id' = 'test-input-signin-id',
  'input.signin.password' = 'test-input-signin-password',
  'button.signin.next' = 'test-button-signin-next',
  'button.signin.submit' = 'test-button-signin-submit',
  'button.signin.back' = 'test-button-signin-back',
  'link.signin.findid' = 'test-link-signin-findid',
  'link.signin.createaccount' = 'test-link-signin-createaccount',
  'checkbox.signin.rememberid' = 'test-checkbox-signin-rememberid',
  'checkbox.signin.staysignedin' = 'test-checkbox-signin-staysignedin',
  'checkbox.signin.showpassword' = 'test-checkbox-signin-showpassword',
  'button.signin.google' = 'test-button-signin-google',
  'button.signin.qrcode' = 'test-button-signin-qrcode',
  'icon.signin.info' = 'test-icon-signin-info',
  'loading.signin.complete' = 'test-loading-signin-complete',

  // QR Code Sign-In
  'qrcode.signin' = 'test-qrcode-signin',
  'button.qrcode.newcode' = 'test-button-qrcode-newcode',
  'button.qrcode.cancel' = 'test-button-qrcode-cancel',

  // Two-Step Verification (2SV)
  'input.2sv.code' = 'test-input-2sv-code',
  'button.2sv.verify' = 'test-button-2sv-verify',
  'button.2sv.resend' = 'test-button-2sv-resend',
  'button.2sv.back' = 'test-button-2sv-back',
  'loading.2sv.authenticate' = 'test-loading-2sv-authenticate',
  'text.2sv.description' = 'test-text-2sv-description',
  'text.2sv.phonenotice' = 'test-text-2sv-phonenotice',
  'button.2sv.signout' = 'test-button-2sv-signout',

  // Adaptive Authentication
  'button.adaptive.email.verify' = 'test-button-adaptive-email-verify',
  'button.adaptive.email.resend' = 'test-button-adaptive-email-resend',
  'button.adaptive.email.gotoinbox' = 'test-button-adaptive-email-gotoinbox',
  'button.adaptive.sms.verify' = 'test-button-adaptive-sms-verify',
  'button.adaptive.sms.resend' = 'test-button-adaptive-sms-resend',
  'input.adaptive.verification.code' = 'test-input-adaptive-verification-code',
  'text.adaptive.description' = 'test-text-adaptive-description',
  'loading.adaptive.verify' = 'test-loading-adaptive-verify',
  'button.adaptive.signout' = 'test-button-adaptive-signout'
}
